export default function splitArrayByPattern(
  array = [],
  { halfFirst = false } = {},
) {
  const result = [];
  const pattern = [1, 2, 2, 3, 3, 3];
  let index = 0;
  let patternIndex = 0;

  if (halfFirst && array.length > 0) {
    // Calculate half size (rounded down)
    const halfChunkSize = Math.floor(pattern[0] / 2);
    const chunk = array.slice(index, index + halfChunkSize);
    result.push(chunk);
    index += halfChunkSize;
    patternIndex = 1; // Skip first full pattern slot, continue loop from next
  }

  while (index < array.length) {
    const chunkSize = pattern[patternIndex];
    const chunk = array.slice(index, index + chunkSize);
    result.push(chunk);
    index += chunkSize;
    patternIndex = (patternIndex + 1) % pattern.length;
  }

  return result;
}
